import { searchPhotos } from '../utils/unsplash.js';

const _esc = s => !s ? '' : String(s).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;');

/**
 * Opens an Unsplash search modal. Returns a Promise that resolves with the selected photo or null.
 */
export function openUnsplashModal(initialQuery = '') {
    return new Promise((resolve) => {
        const overlay = document.createElement('div');
        overlay.className = 'unsplash-modal-overlay';
        overlay.innerHTML = `
            <div class="unsplash-modal">
                <div class="unsplash-modal__header">
                    <span class="unsplash-modal__title">Search Stock Photos</span>
                    <button class="unsplash-modal__close">&times;</button>
                </div>
                <div class="unsplash-modal__search">
                    <input type="text" class="unsplash-modal__input" placeholder="Search for photos..." value="${initialQuery}" autofocus />
                    <button class="btn btn-primary btn-sm unsplash-modal__search-btn">Search</button>
                </div>
                <div class="unsplash-modal__results">
                    ${initialQuery ? '<div class="unsplash-modal__loading">Searching...</div>' : '<div class="unsplash-modal__hint">Type a keyword and press Search</div>'}
                </div>
                <div class="unsplash-modal__footer">
                    <span class="unsplash-modal__credit">Photos by <a href="https://unsplash.com" target="_blank" rel="noopener">Unsplash</a></span>
                </div>
            </div>
        `;

        document.body.appendChild(overlay);

        const input = overlay.querySelector('.unsplash-modal__input');
        const searchBtn = overlay.querySelector('.unsplash-modal__search-btn');
        const results = overlay.querySelector('.unsplash-modal__results');
        const closeBtn = overlay.querySelector('.unsplash-modal__close');

        function close(result = null) {
            overlay.remove();
            resolve(result);
        }

        closeBtn.addEventListener('click', () => close(null));
        overlay.addEventListener('click', (e) => { if (e.target === overlay) close(null); });

        async function doSearch() {
            const q = input.value.trim();
            if (!q) return;
            results.innerHTML = '<div class="unsplash-modal__loading">Searching...</div>';
            try {
                const photos = await searchPhotos(q);
                if (!photos.length) {
                    results.innerHTML = '<div class="unsplash-modal__hint">No photos found. Try a different keyword.</div>';
                    return;
                }
                results.innerHTML = photos.map(p => `
                    <div class="unsplash-photo" data-url="${_esc(p.url)}" data-alt="${_esc(p.alt)}">
                        <img src="${_esc(p.thumb)}" alt="${_esc(p.alt)}" loading="lazy" />
                        <div class="unsplash-photo__credit">by ${_esc(p.author)}</div>
                    </div>
                `).join('');

                results.querySelectorAll('.unsplash-photo').forEach(el => {
                    el.addEventListener('click', () => close({
                        url: el.dataset.url,
                        alt: el.dataset.alt
                    }));
                });
            } catch (e) {
                results.innerHTML = `<div class="unsplash-modal__error">${_esc(e.message)}</div>`;
            }
        }

        searchBtn.addEventListener('click', doSearch);
        input.addEventListener('keydown', (e) => { if (e.key === 'Enter') doSearch(); });

        if (initialQuery) doSearch();
    });
}
